export default class HeartrateZoner {
  constructor(props) {
    this.data = { 
      age: 0,
      bpm: 0
    }

  }

  zoneColors = [
    '#c5c5c5',
    '#bd90a4',
    '#00a2ff',
    '#00a400',
    '#ff8300',
    '#ff0000',
    '#9adaff' //zone 6 is for no bpm
  ]

  zoneColor = (zone=this.zoneNum()) => this.zoneColors[zone]
    
  zoneDataKey = {
    'training' : 0,
    'label' : 1,
    'health' : 2,
    'perc' : 3,
    'desc' : 4,
  }

  zoneData = [
    [
      "Resting",
      "minimal",
      "Minimal",
      '0-50%',
      ''
    ],
    [
      "Warm-Up",
      "very_light",
      "Very Light",
      '50-60%',
      'Improves overall health and helps recovery',
    ],
    [
      "Fitness / Fat Burn",
      "light",
      "Light",
      '60-70%',
      'Improves basic endurance and fat burning',
    ],
    [
      "Cardio Training / Endurance",
      "moderate",
      "Moderate",
      '70-80%',
      'Improves aerobic fitness',
    ],
    [
      "Hardcore Training",
      "significant",
      "Hard",
      '80-90%',
      'Increases maximum performance capacity',
    ],
    [
      "Maximum Training",
      "maximum",
      "Very Hard",
      '90-100%',
      'Develops maximum performance and speed',
    ],
  ]

  setData = (data) => {
    this.data = data
  }

  hrmax = () => Math.round(211 - (0.64 * this.data.age))

  percent = () => Math.round(this.data.bpm / this.hrmax() * 100)

  zoneNum = () => {
    const p = this.percent()
    if (p > 90 ) return 5
    if (p > 80 ) return 4
    if (p > 70 ) return 3
    if (p > 60 ) return 2
    if (p > 50 ) return 1
    return 0
  }

  zoneInfo = (type, zone=this.zoneNum()) => this.zoneData[zone][this.zoneDataKey[type]]
}
